import { render, staticRenderFns } from "./LiveReceptionist.vue?vue&type=template&id=2fc46a6e"
import script from "./LiveReceptionist.vue?vue&type=script&lang=js"
export * from "./LiveReceptionist.vue?vue&type=script&lang=js"
import style0 from "./LiveReceptionist.vue?vue&type=style&index=0&id=2fc46a6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports